var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('SideModal', {
    staticStyle: {
      "width": "60% !important",
      "margin-left": "0 !important"
    },
    attrs: {
      "show": _vm.isShow,
      "body-class": "doctor-patient-chat-modal",
      "title": "Doctor-Patient Chat",
      "z-index": 9999
    },
    on: {
      "exit": function ($event) {
        _vm.isShow = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_vm.showMessages && _vm.patient ? _c('ChatMessagesColumn', {
          staticClass: "mt-3",
          attrs: {
            "conversation": _vm.selectedConversation,
            "category": _vm.selectedCategory,
            "is-messages-loaded": _vm.showMessages,
            "slide-mode": true,
            "show-input": false,
            "show-action-bar": false,
            "doctor-patient-mode": true
          },
          on: {
            "close-apc-slide": function ($event) {
              _vm.isShow = false;
            }
          }
        }) : _vm._e()];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };